import BlogMeta from "./blogMeta";
import ConvertkitForm from "./convertKitForm";
import Anchor from "./dls/anchor";
import Figure from "./figure";

const Hr = () => {
  const { colorMode } = useColorMode();
  const borderColor = {
    light: "gray.200",
    dark: "gray.600",
  };

  return <div borderColor={borderColor[colorMode]} my={4} w="100%" />;
};

const components = {
  h1: (props) => <h1 as="h1" size="xl" my={4} {...props} />,
  h2: (props) => <h2 as="h2" size="lg" my={4} {...props} />,
  h3: (props) => <h3 as="h3" size="md" my={4} {...props} />,
  p: (props) => <p as="p" mt={4} lineHeight="tall" {...props} />,
  ul: (props) => <ul as="ul" pt={2} pl={4} ml={2} {...props} />,
  ol: (props) => <ol as="ol" pt={2} pl={4} ml={2} {...props} />,
  li: (props) => <li as="li" pb={1} {...props} />,
  a: Anchor,
  Anchor: (props) => <a as="li" pb={1} {...props} />,
  hr: Hr,
  OutboundAnchor: Anchor,
  inlineCode: (props) => <div {...props} colorScheme="red" />,
  BlogMeta,
  ConvertkitForm,
  Figure,
};

export default components;
